var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useSession from '../hooks/use-session';
var RouteWithSubRoutes = function RouteWithSubRoutes(route) {
  var _useSession = useSession(),
    isAuthed = _useSession.isAuthed,
    current = _useSession.current;
  return React.createElement(Route, {
    path: route.path,
    exact: route.exact !== null ? route.exact : true,
    render: function render(prps) {
      if (route.private) {
        if (isAuthed) {
          if (!!current && (current.attributes.passwordResetRequired || current.attributes['password-reset-required']) && !(window.location.pathname.includes('user/change-password') || window.location.pathname.includes('logout'))) {
            return React.createElement(Redirect, {
              to: {
                pathname: '/user/change-password',
                state: {
                  from: prps.location
                }
              }
            });
          }
          return React.createElement(route.component, _extends({}, route, prps));
        }
        return React.createElement(Redirect, {
          to: {
            pathname: '/login',
            state: {
              from: prps.location
            }
          }
        });
      }
      return React.createElement(route.component, _extends({}, route, prps));
    }
  });
};
export default RouteWithSubRoutes;